import { PersonIcon, RocketIcon } from '@/assets/icons'
import React from 'react'
import {
    AdminButton,
    BackButton,
    HeaderActions,
    HeaderContainer,
    HeaderContent,
    Logo,
    LogoutButton,
    MyProfileButton,
    MyTripsButton,
} from './Header.styles'

interface HeaderProps {
	onLogout?: () => void
	showBackButton?: boolean
	onBackClick?: () => void
	backButtonText?: string
	onMyTripsClick?: () => void
	onMyProfileClick?: () => void
	onAdminClick?: () => void
}

const Header: React.FC<HeaderProps> = ({
	onLogout,
	showBackButton = false,
	onBackClick,
	backButtonText = 'Back',
	onMyTripsClick,
	onMyProfileClick,
	onAdminClick,
}) => {
	return (
		<HeaderContainer>
			<HeaderContent>
				<Logo>Orbit</Logo>
				<HeaderActions>
					{onAdminClick && <AdminButton onClick={onAdminClick}>Admin</AdminButton>}
					{onMyTripsClick && (
						<MyTripsButton onClick={onMyTripsClick}>
							<RocketIcon width={18} height={18} fill="currentColor" />
							<span>My Trips</span>
						</MyTripsButton>
					)}
					{onMyProfileClick && (
						<MyProfileButton onClick={onMyProfileClick}>
							<PersonIcon width={18} height={18} fill="currentColor" />
							<span>My Profile</span>
						</MyProfileButton>
					)}
					{showBackButton && onBackClick && (
						<BackButton onClick={onBackClick}>← {backButtonText}</BackButton>
					)}
					{onLogout && <LogoutButton onClick={onLogout}>Logout</LogoutButton>}
				</HeaderActions>
			</HeaderContent>
		</HeaderContainer>
	)
}

export default Header
